import { Type } from 'class-transformer';

export class IPostSessionPersonaleBodyDto {
  personId: string | number;
  sessionId: string | number;
  type: number;
}

export class ISessionPersonale {
  id: number;
  personId: string | number;
  sessionId: string | number;
  type: number;
}

export class ISessionPersonaleResponse {
  @Type(() => ISessionPersonale)
  result: ISessionPersonale;
}

export class IQuerySessionPersonale {
  personId?: string | number;
  sessionId?: string | number;
  type?: number;
}

export class ISessionPersonaleListResponse {
  @Type(() => ISessionPersonale)
  results: ISessionPersonale[];
}
